const LABELS = {
    includeInMainreport: "Include in main report",
    notes: "Notes",
    accessoriesAboveESP: "Accessories above ESP",
    equipment: "Equipments",
    pn: "PN",
    length: "Length (ft)",
    weight: "Weight (lbs)",
    diameter: "Diameter (in)",
    setDepth: "Set depth (ft)",
    espEquipments: "ESP equipment",
    surfaceEquip: "Surface equipment",
    cable: "Cable",
    dim: 'Dim. (T"xW")',
    mle: 'MLE',
    boh: 'BOH',
    pump: "Pump series - 400",
    gasHandlingIntake: "Gas handlers",
    gasSeparator: "Gas separator",
    protectors: "Protectors",
    motor: "Motor",
    sensor: "Sensor",
    accessoriesBelowESP: "Desander",
    miscellaneous: "Miscellaneous",
    equipmentAccessories: "Equipment / Accessories",
    type: "Type",
    provider: "Provider",
    quantity: "Quantity",
    setDepthSummary: "Set depth summary",
    surfaceCableLength: "Surface cable length (ft)",
    cableClamps: "Cable clamps",
    mleClamps: "MLE clamps",
    mleGuards: "MLE guards/Protectors",
    sandGuards: "Sand guards",
    desander: "Desander",
    gasGuard: "Gasguard / Gas regulator",
    drainValue: "Drain valve",
    checkValue: "Check valve",
    centralizer: "Centralizer",
    ctLine: "CT line",
    eoTubing: "EOTubing (ft)",
    intakeSetDepth: "Intake set depth (ft)",
    sensorDepth: "Sensor depth (ft)",
    mleLengthForSplice: "MLE length for splice",
    totalEspLength: "Total ESP length",
    espDesander: "ESP + Desander + Tailpipe",
    totalDownholeEquipmentWeight: "Total downhole equipment weight",
    recommendedParameters: "Recommended parameters",
    startupFreq: "Startup freq",
    calculationsATDiffFreq: "Calculations at different frequencies",
    minStart: "Min/Start",
    design: "Design",
    max: "Max",
    frequency: "Frequency",
    requiredSurface: "Required surface (Volts)",
    maxAvailXformer: "Max Avail. Xformer (Volts) with 435V input",
    xFormerBalance: "Xformer (Volts) balance",
    maxVSDAvailable: "Max VSD (kVA) available",
    vsdRequired: "VSD (kVA) required",
    pumpBJPRequired: "Pump BHP required (HP)",
    vsdLoad: "VSD (kVA) load (%)",
    motorLoad: "Motor load (%)",
    xFormerLoad: "Xformer load (%)",
    ft: "ft",
    lb: "lb",
    totalJoints: "Tail pipe"
};

export default LABELS;